import { ReactNode } from "react";
import GridTileSkeleton from "./skeletons/grid-tile-skeleton";
interface ResponsiveGridProps {
  children?: ReactNode;
  reduced?: boolean;
  className?: string;
  /**
   * Indicates if it should show skeletons or children
   */
  loading?: boolean;
}

const ResponsiveGrid = ({
  children,
  reduced,
  className,
  loading,
}: ResponsiveGridProps) => (
  <div
    className={`grid auto-rows-min grid-cols-1 sm:grid-cols-2 md:grid-cols-3 ${
      reduced
        ? "xl:grid-cols-3 2xl:grid-cols-4"
        : "xl:grid-cols-4 2xl:grid-cols-5"
    } gap-x-6 gap-y-8 lg:-mx-5 ${className}`}
  >
    {loading
      ? Array.from(Array(10).keys()).map((key) => (
          <GridTileSkeleton key={key} />
        ))
      : children}
  </div>
);

export default ResponsiveGrid;
